// import {
//   DropdownMenu,
//   DropdownMenuTrigger,
//   DropdownMenuContent,
//   DropdownMenuItem,
//   DropdownMenuSub,
//   DropdownMenuSubTrigger,
//   DropdownMenuSubContent,
// } from "@/components/ui/dropdown-menu";
// import { useState } from "react";
// import { Link, useLocation } from "react-router-dom";

// export const servicesMenu = [
//   {
//     title: "Regulatory Services",
//     items: [
//       { name: "Strategic Regulatory Planning", path: "/regulatory-services/strategic-regulatory-planning" },
//       { name: "Comprehensive eCTD & SPL Publishing Services", path: "/regulatory-services/comprehensive-ectd-spl" },
//       { name: "Global Drug Master File (DMF) Classification", path: "/regulatory-services/global-drug-master-file-dmf" },
//       { name: "Dossier Management", path: "/regulatory-services/dossier-management" },
//       { name: "Regulatory Representation Services", path: "/regulatory-services/regulatory-representation-services" },
//       { name: "Regulatory Support Services", path: "/regulatory-services/regulatory-support-services" },
//     ],
//   },
//   {
//     title: "GMP Audits & Compliance",
//     items: [
//       { name: "GMP Audits Compliance & Training Services", path: "/gmp-audits-and-compliance/gmp-audits-compliance-and-training-services" },
//     ],
//   },
//   {
//     title: "IT Solutions for Pharma",
//     items: [
//       { name: "Enterprise Quality Management System (EQMS)", path: "/it-solutions-for-pharma/enterprise-quality-management-system-eqms" },
//       { name: "eCTD Publishing Software", path: "/it-solutions-for-pharma/ectd-publishing-software" },
//       { name: "Pharmacovigilance & Drug Safety Software", path: "/it-solutions-for-pharma/pharmacovigilance-and-drug-safety-software" },
//       { name: "Clinical Trial Management Platform", path: "/it-solutions-for-pharma/clinical-trial-management-platform" },
//     ],
//   },
//   {
//     title: "Pharma Project Management",
//     items: [
//       { name: "Product Development – API & Formulations", path: "/pharma-project-management/product-development-api-and-formulations" },
//       { name: "Analytical Development & Microbiology Services", path: "/pharma-project-management/analytical-development-and-microbiology-services" },
//       { name: "Business Development Services", path: "/pharma-project-management/business-development-services" },
//     ],
//   },
//   {
//     title: "Trainings",
//     items: [
//       { name: "Regulatory Training Programs", path: "/trainings/regulatory-training-programs" },
//       { name: "GMP Training Programs", path: "/trainings/gmp-training-programs" },
//       { name: "Corporate Training & Professional Development", path: "/trainings/corporate-training-and-professional-development" },
//     ],
//   },
//   {
//     title: "Product Development & Analytical Solutions",
//     items: [
//       { name: "Integrated Analytical & Product Characterization Services", path: "/product-development-and-analytical-solutions/integrated-analytical-and-product-characterization-services" },
//       { name: "Product Development & Analytical Solutions", path: "/product-development-and-analytical-solutions/product-development-and-analytical-solutions" },
//     ],
//   },
// ];

// const servicePaths = [
//   "/regulatory-services",
//   "/gmp-audits-and-compliance",
//   "/it-solutions-for-pharma",
//   "/pharma-project-management",
//   "/trainings",
//   "/product-development-and-analytical-solutions"
// ];

// export function ServicesMenu() {
//   const [isOpen, setIsOpen] = useState(false);
//   const location = useLocation();
//   const isActive = servicePaths.some(path =>
//     location.pathname.startsWith(path)
//   );
//   return (
//     <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
//       <DropdownMenuTrigger asChild>
//         <button className={`text-gray-700 hover:text-blue-900 px-3 py-2 text-sm font-medium transition-colors cursor-pointer ${isActive ? 'active-link' : ''}`}>
//           Our Services
//         </button>
//       </DropdownMenuTrigger>
//       <DropdownMenuContent className="w-80">
//         {servicesMenu.map((category, index) => (
//           <DropdownMenuSub key={index}>
//             <DropdownMenuSubTrigger className="font-semibold text-gray-800">
//               {category.title}
//             </DropdownMenuSubTrigger>
//             <DropdownMenuSubContent className="bg-white shadow-lg border rounded-md">
//               {category.items.map((item, idx) => (
//                 <DropdownMenuItem key={idx}>
//                   <Link to={item.path} className="text-gray-600 hover:text-blue-900" onClick={() => setIsOpen(false)}>
//                     {item.name}
//                   </Link>
//                 </DropdownMenuItem>
//               ))}
//             </DropdownMenuSubContent>
//           </DropdownMenuSub>
//         ))}
//       </DropdownMenuContent>
//     </DropdownMenu>
//   );
// }




import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuSubContent,
} from "@/components/ui/dropdown-menu";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { servicesMenu } from "./ServicesData"; // import from new file

export function ServicesMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const servicePaths = servicesMenu.map(s => "/" + s.title.toLowerCase().replace(/\s+/g, "-"));
  
  const isActive = servicePaths.some(path =>
    location.pathname.startsWith(path)
  );

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <button className={`text-gray-700 hover:text-blue-900 px-3 py-2 text-sm font-medium transition-colors cursor-pointer ${isActive ? 'active-link' : ''}`}>
          Our Services
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-80">
        {servicesMenu.map((category, index) => (
          <DropdownMenuSub key={index}>
            <DropdownMenuSubTrigger className="font-semibold text-gray-800">
              {category.title}
            </DropdownMenuSubTrigger>
            <DropdownMenuSubContent className="bg-white shadow-lg border rounded-md">
              {category.items.map((item, idx) => (
                <DropdownMenuItem key={idx}>
                  <Link to={item.path} className="text-gray-600 hover:text-blue-900" onClick={() => setIsOpen(false)}>
                    {item.name}
                  </Link>
                </DropdownMenuItem>
              ))}
            </DropdownMenuSubContent>
          </DropdownMenuSub>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
